import { CONFERENCE_LEFT, CONFERENCE_WILL_JOIN, CONFERENCE_WILL_LEAVE } from '../base/conference/actionTypes';
import { getConferenceP2PDecision } from '../base/conference/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { TRACK_UPDATED } from '../base/tracks/actionTypes';
import { emitMobileTelemetryEvent } from '../mobile/navigation/telemetry';
import { isObserverRoomPage } from '../vrs-auth/observerRoomPage';
import { getPersistentJson } from '../vrs-auth/storage';
import { TransportMonitor, countConferencePeople, getActiveTransport, guardConferenceP2P, remoteVideoFlow, setActiveTransport } from './p2pTransport';
/**
 * One event per move between direct and the bridge, when it settles
 * (p2pTransport.ts). Numbers and enums only.
 */
export const TRANSPORT_SWITCH_EVENT = 'vrs_media_transport_switch';
function reportSwitch(getState, conference, switchReport) {
    // A manager's hidden observation sends no call telemetry.
    if (isObserverRoomPage()) {
        return;
    }
    const roomName = getState()['features/base/conference'].room;
    const stored = getPersistentJson('vrs_active_call');
    const call = roomName && stored?.roomName === roomName ? stored : undefined;
    const people = countConferencePeople(conference);
    emitMobileTelemetryEvent(TRANSPORT_SWITCH_EVENT, {
        ...switchReport,
        hiddenParticipants: people?.hidden,
        participantCount: people?.visible
    }, {
        callId: call?.callId,
        requestId: call?.requestId,
        roomName,
        state: switchReport.settled
    });
}
function startTransport(store, conference) {
    const decision = getConferenceP2PDecision(store.getState());
    const monitor = new TransportMonitor(conference, {
        remoteVideo: transport => remoteVideoFlow(store.getState()['features/base/tracks'], transport),
        report: switchReport => reportSwitch(store.getState, conference, switchReport)
    });
    if (!guardConferenceP2P(conference, () => Boolean(monitor.fellBack())) && decision.enabled) {
        // No rule to wrap in this lib-jitsi-meet: the hidden-peer rule cannot
        // be kept, so this conference stays on the bridge.
        try {
            if (conference.options?.config?.p2p) {
                conference.options.config.p2p.enabled = false;
            }
        }
        catch { /* nothing more to do */ }
    }
    setActiveTransport({ conference, decision, monitor });
}
function stopTransport(conference) {
    const active = getActiveTransport(conference);
    if (active) {
        active.monitor.dispose();
        setActiveTransport(undefined);
    }
}
MiddlewareRegistry.register(store => next => action => {
    const result = next(action);
    switch (action.type) {
        case CONFERENCE_WILL_JOIN:
            // The same conference is dispatched again after an authentication
            // step; it keeps its monitor.
            if (action.conference && !getActiveTransport(action.conference)) {
                stopTransport(getActiveTransport()?.conference);
                startTransport(store, action.conference);
            }
            break;
        case CONFERENCE_WILL_LEAVE:
        case CONFERENCE_LEFT:
            stopTransport(action.conference);
            break;
        case TRACK_UPDATED: {
            const track = action.track;
            const jitsiTrack = track?.jitsiTrack;
            if (track?.videoStarted === true && jitsiTrack && jitsiTrack.isLocal?.() === false
                && jitsiTrack.getType?.() === 'video') {
                getActiveTransport()?.monitor.remoteVideoStarted(Boolean(jitsiTrack.isP2P));
            }
            break;
        }
    }
    return result;
});
